// extracted by mini-css-extract-plugin
module.exports = {"sider_box":"sider_box-3D8aXFR4","stock_box":"stock_box-28wqt67c clearfix","sider_list":"sider_list-34aE0AnP"};